import React from "react";
import "./Title.scss";

export default function Title({ children }: { children: string }) {
  return <h1 className="title-seccion-page mt-5">{children}</h1>;
}
